import { ArrowUpDown } from '@ankr.com/ui';
import { Button } from '@mui/material';
import { useCallback } from 'react';

import { Placeholder } from 'modules/common/components/Placeholder';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useMenu } from 'modules/common/hooks/useMenu';
import { useTeamAccountsPrefetch } from 'modules/teamAccount/actions/fetchTeamAccounts';

import { AccountMenuButtonSkeleton } from '../AccountMenuButtonSkeleton';
import { SelectedGroupAvatar } from '../SelectedGroupAvatar';
import { useAccountMenuButtonStyles } from './useAccountMenuButtonStyles';

export interface AccountMenuButtonProps {
  isMenuOpen: boolean;
  onClick: ReturnType<typeof useMenu>['handleOpen'];
}

export const AccountMenuButton = ({
  isMenuOpen,
  onClick,
}: AccountMenuButtonProps) => {
  const { classes } = useAccountMenuButtonStyles(isMenuOpen);

  const { isAccountInitializing } = useAccount();

  const prefetchGroupAccounts = useTeamAccountsPrefetch('fetchTeamAccounts');

  const onMouseEnter = useCallback(
    () => prefetchGroupAccounts(),
    [prefetchGroupAccounts],
  );

  return (
    <Placeholder
      hasPlaceholder={isAccountInitializing}
      placeholder={<AccountMenuButtonSkeleton />}
    >
      <Button
        className={classes.root}
        classes={{
          endIcon: classes.endIcon,
        }}
        endIcon={<ArrowUpDown />}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        variant="text"
      >
        <SelectedGroupAvatar />
      </Button>
    </Placeholder>
  );
};
